import React, { useState, useEffect } from "react";
import "./Home.css";
import hamburger from "./icons/hamburger.svg";
import logo from "./logo.svg";
import { commitLocalUpdate } from "react-relay";
import environment from "./Environment";

import ScrollTopButton from "./components/ScrollTopButton";
// import PremiumButton from "./components/PremiumButton";
import Welcome from "./containers/Welcome";
import PostViewContainerWrapper from "./components/PostViewContainerWrapper";
import BookmarkViewContainer from "./components/BookmarkViewContainer";
import DetailViewWrapper from "./DetailViewWrapper";
import { useMediaQuery } from "react-responsive";
import ProductDemoModal from "./components/ProductDemoModal";
import { Close32 } from "@carbon/icons-react";
import { useNavigate, useLocation } from "react-router-dom";

function Home(props) {
    const [scrolling, setScrolling] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });
    const {
        metaDescription,
        metaSourceName,
        scrollPosition,
        isHomeReturn,
        isProductDemoActivated,
        selectedLeads,
        selectedSentimentPostIds,
        filterTerms,
        isAdvancedSearch,
        isRightNavActivated,
    } = props.settings;

    const user = props.user;
    const navigate = useNavigate();
    const location = useLocation();
    // useEffect(() => {
    // 	window.addEventListener("scroll", handleScroll);
    // 	if (isHomeReturn) {
    // 		// window.scrollTo(0, parseInt(scrollPosition));
    // 		window.scroll({
    // 			top: parseInt(scrollPosition),
    // 			left: 0,
    // 			behavior: "smooth"
    // 		});
    // 	}
    // 	return () => {
    // 		window.removeEventListener("scroll", handleScroll);
    // 	};
    // });


    let navbarState = "closed";

    function onHideButtonClick(e) {
        e.preventDefault();
        setIsVisible(!isVisible);
    }

    function handleScroll(e) {
        setScrolling(true);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isHomeReturn");
        });
    }

    function setIsModalActive() {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(!isProductDemoActivated, "isProductDemoActivated");
        });
    }

    function onMetaClose(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue([], "selectedLeads");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue("Articles from ", "metaDescription");
            record.setValue(false, "isAdvancedSearch");
        });
    }

    return (
        <>
            {isSmallScreen ? (
                <div id="main" className={`main-false`}>
                    {metaSourceName !== "" ? (
                        <div className="meta-desc">
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {selectedLeads.length != 0 ||
                                selectedSentimentPostIds.length != 0 ||
                                filterTerms.length != 0 ||
                                isAdvancedSearch ? (
                                    <Close32 onClick={onMetaClose} />
                                ) : null}
                                {metaDescription} {'"'} {metaSourceName} {'"'}
                            </span>
                        </div>
                    ) : (
                        <div className="meta-desc">
                            <span>{metaDescription}</span>
                        </div>
                    )}

                    <div className={`postview-container-wrapper`}>
                        <PostViewContainerWrapper
                            user={props.user}
                            settings={props.settings}
                            selectedSourceId={props.selectedSourceId}
                        />
                    </div>

                    <div className="content-wrapper">
                        <ScrollTopButton />
                    </div>
                    <footer>&copy; opencover technologies pvt. ltd.</footer>
                </div>
            ) : (
                <div id="main" className={`main-${props.navbarState}`}>
                    {isProductDemoActivated ? (
                        <ProductDemoModal
                            title="Demo"
                            isModalActive={isProductDemoActivated}
                            setIsModalActive={setIsModalActive}
                            settings={props.settings}
                            user={props.user}
                        />
                    ) : null}
                    {metaSourceName !== "" ? (
                        <div className="meta-desc">
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {selectedLeads.length != 0 ||
                                selectedSentimentPostIds.length != 0 ||
                                filterTerms.length != 0 ||
                                isAdvancedSearch ? (
                                    <Close32 onClick={onMetaClose} />
                                ) : null}
                                {metaDescription} {'"'} {metaSourceName} {'"'}
                            </span>
                        </div>
                    ) : (
                        <div className="meta-desc">
                            <span>{metaDescription}</span>
                        </div>
                    )}

                    <div className={`postview-container-wrapper`}>
                        <PostViewContainerWrapper
                            user={props.user}
                            settings={props.settings}
                            selectedSourceId={props.selectedSourceId}
                        />
                    </div>

                    <div className="content-wrapper">
                        <ScrollTopButton />
                    </div>
                    <footer>&copy; opencover technologies pvt. ltd.</footer>
                </div>
            )}
        </>
    );
}

export default Home;
